import React, { useEffect, useLayoutEffect, useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

export interface IFilenameForm {
    filename: string;
}
interface IFilenameFormProps {
    title: string;
    editedItem: IFilenameForm;
    cancel: () => void;
    //ok: () => void;
    submit: (data: IFilenameForm) => void;
}
const validationSchema = z.object({
    filename: z.string().trim().min(1),
});
export function FilenameForm(props: IFilenameFormProps) {
    const cancel = () => props.cancel();

    const {
        register, handleSubmit, reset, formState: { errors }, control, watch, setFocus
    } = useForm<IFilenameForm>({
        resolver: zodResolver(validationSchema),
        //defaultValues: props.editedItem,
        values: props.editedItem,
        resetOptions: {
            keepDirtyValues: true,
            keepErrors: true, // input errors will be retained with value update
        }
    });

    useLayoutEffect(() => {
        console.log("hugo, ");
        setTimeout(() => {
            setFocus('filename', { shouldSelect: true });
        }, 0);
    }, [setFocus]);

    return (
        <>
            <Modal show={true} onHide={cancel} size='lg'>
                <Form onSubmit={handleSubmit(props.submit)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className={`mb-3 ${errors.filename ? 'is-invalid' : ''}`} controlId="formDirectoryName">
                            <Form.Label>Namn</Form.Label>

                            <Controller
                                control={control}
                                name="filename"
                                render={({
                                    field: { onChange, onBlur, value: formFieldValue, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,
                                }) => {
                                    //console.log("error", error);

                                    return (
                                        <>
                                            <Form.Control
                                                onChange={(raw) => {
                                                    return onChange(raw);
                                                }}
                                                value={formFieldValue}

                                                type="text"
                                                className={`${errors.filename ? 'is-invalid' : ''}`}
                                                ref={ref}

                                            />
                                        </>
                                    );
                                }} />

                            {errors.filename && (
                                <Form.Control.Feedback type="invalid" className='d-block'>Detta fält är obligatoriskt.</Form.Control.Feedback>
                            )}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={cancel}>
                            Stäng
                        </Button>
                        <Button variant="primary" type="submit">
                            Spara
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>

    );
}
